import { useGetPublicHealthStatistikYearly } from '@tatatemplate/shared-lib'

export const useHealthStatistics = () => {
  return useGetPublicHealthStatistikYearly({
    query: {
      queryKey: ['health', 'statistics', 'yearly'],
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  })
}

export default useHealthStatistics
